import React from "react";
import "./App.css";
import store from "./store";
import { Provider } from "react-redux";
import HomePage from "./components/HomePage";


function App() {
  return (
    <Provider store={store}>
      <HomePage />
    </Provider>
  );
}

export default App;
